import React from "react";
import AllNodata from "../../../assets/All_NoData.svg";
import NoDataImg from "../../../assets/no-data-found.png";
import NoDataFoundAnimation from "../../utils/animation/NoDataFoundAnimation";
import NoAccessWidget from "./NoAccess";

const NoGraphData = ({
  errorCode,
  isPreviewState,
  isDeepDiveList,
  isDeepDiveTimeLineList,
  trends,
  isCommandCenterScreen,
  isDeepDiveDashboard,
}) => {
  return (
    <div
      style={{
        height: trends
          ? "100vh"
          : isPreviewState
          ? "29rem"
          : isDeepDiveList
          ? "26rem"
          : isDeepDiveDashboard
          ? "45rem"
          : "",
      }}
      className={`d-flex ${
        isPreviewState || isCommandCenterScreen || isDeepDiveDashboard
          ? ""
          : "full_nodata"
      } ${
        isCommandCenterScreen ? "CommandCenter--nodata " : ""
      } align-items-center`}
    >
      <div
        className={`w-100 text-center ${isDeepDiveDashboard ? "m-auto" : ""}`}
      >
        <div className={`Nodata_img ${isCommandCenterScreen ? "" : "mb-15"} `}>
          <img
            src={isCommandCenterScreen ? NoDataImg : AllNodata}
            alt="no data"
            style={
              isCommandCenterScreen
                ? { maxWidth: "20rem", margin: "auto" }
                : isDeepDiveTimeLineList
                ? { width: "10rem" }
                : isDeepDiveDashboard
                ? { minWidth: "25rem" }
                : {}
            }
          />
        </div>
        <div
          className={`${
            isCommandCenterScreen ? "Nodata_img--text" : ""
          } text_regular-gray`}
        >
          {errorCode ? errorCode : "No data found"}
        </div>
      </div>
    </div>
  );
};

export default NoGraphData;
